<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:45:13
 * @FilePath: \YunYin_admin\src\views\Village\SetQuery\Organization.vue
-->
<template>
  <el-main class="base">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <el-container>
        <el-aside class="left" width="238px">
          <div class="one-group" v-if="oneGroupList.length > 0">
            <div
              class="one-group-item"
              v-for="item in oneGroupList"
              :key="item.id"
              :class="{ 'active-group-item': activeId == item.id }"
              :title="item.groupName"
              @click="selectGroup(item)"
            >
              {{ item.groupName }}
            </div>
          </div>
          <div v-else class="not-data">暂无数据</div>
        </el-aside>
        <el-main class="right" v-loading="twoGroupLoad">
          <div class="two-group" v-if="twoGroupList.length > 0">
            <div class="two-group-herder two-group-item">村民小组名称</div>
            <div class="two-group-scroll">
              <div
                class="two-group-item"
                v-for="item in twoGroupList"
                :key="item.id"
              >
                {{ item.groupName }}
              </div>
            </div>
          </div>
          <div v-else class="not-data">暂无数据</div>
        </el-main>
      </el-container>
    </div>
  </el-main>
</template>

<script>
export default {
  name: "Organization",
  data() {
    return {
      oneGroupList: [],
      twoGroupList: [],
      activeId: "",
      twoGroupLoad: false,
      masterId: "",
    };
  },
  components: {},
  filters: {},
  watch: {},
  created() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.getOneLevelGroup({ masterId: $businessAccountId }, (id) => {
      this.activeId = id;
      this.getTwoLevelGroup(id);
    });
  },
  mounted() {},
  methods: {
    /**
     * @description: 获取一级组织目录
     * @Author: yangsibo
     * @Date: 2022-06-07 10:36:09
     * @param {*} masterId 村集体id
     */
    async getOneLevelGroup(masterId, callback) {
      try {
        let { data } = await this.$http.village.oneLevelVillGroup(masterId);
        this.oneGroupList = data;
        callback && callback(data[0].id);
      } catch (error) {}
    },
    /**
     * @description: 获取二级组织目录
     * @Author: yangsibo
     * @Date: 2022-06-07 11:10:19
     * @param {*} id
     * @return {*}
     */
    async getTwoLevelGroup(id) {
      this.twoGroupLoad = true;
      try {
        let { data } = await this.$http.village.twoLevelVillGroup({
          id,
          masterId: this.masterId,
        });
        this.twoGroupList = data;
        this.twoGroupLoad = false;
      } catch (error) {
        this.twoGroupLoad = false;
      }
    },
    /**
     * @description: 选中一级组织
     * @Author: yangsibo
     * @Date: 2022-06-07 11:20:33
     * @param {*} group 选中的一级组织
     */
    selectGroup(group) {
      this.activeId = group.id;
      this.getTwoLevelGroup(group.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  box-sizing: border-box;
  height: calc(100% - 70px);
  .main {
    max-height: calc(100% - 98px);
    ::v-deep .el-container {
      height: 100%;
      background: #fff;
      .left {
        border-right: 1px solid #efefef;
        padding: 15px 15px 15px 0;
        max-width: 100%;
        overflow-y: auto;
        position: relative;
        .not-data {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ccc;
        }
        .one-group {
          .one-group-item {
            width: 100%;
            height: 48px;
            background: #f2f3f5;
            margin-bottom: 8px;
            text-align: center;
            line-height: 48px;
            font-size: 16px;
            color: #222222;
            box-sizing: border-box;
            padding: 0 15px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            &:hover {
              background: #e1f4f5;
              color: #018388;
            }
            &.active-group-item {
              background: #e1f4f5;
              color: #018388;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 4px;
                height: 100%;
                background: #018388;
              }
            }
          }
        }
      }
      .right {
        padding: 15px;
        position: relative;
        .two-group {
          width: 100%;
          border: 1px solid #dfe7eb;
          border-radius: 3px;
          box-sizing: border-box;
          overflow: hidden;
          .two-group-item {
            box-sizing: border-box;
            width: 100%;
            height: 50px;
            line-height: 50px;
            background: #fff;
            border-bottom: 1px solid #dfe7eb;
            padding-left: 46px;
            &:nth-last-child(1) {
              border-bottom: 0;
            }
            &.two-group-herder {
              background: #f1f5f8;
            }
            &:hover {
              background: #f5f7fa;
            }
          }
          .two-group-scroll {
            box-sizing: border-box;
            overflow-y: auto;
            height: calc(100% - 50px);
          }
        }
        .not-data {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ccc;
        }
      }
    }
  }
}
</style>
